export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/shigonghetonglvyuebaoxian-fed3e28d70f1ec7c4a7545106deea98d.png";